import { getMsg } from "../../utils";

// versucht: (1) direkte Felder, (2) JSON aus msg parsen, (3) Regex-Fallback
export function getAuditFields(row) {
  const directAction =
    row?.action ?? row?.fields?.action ?? row?.labels?.action ?? row?.stream?.action ?? row?.parsed?.action;

  const directHostCodeMasked =
    row?.meta?.hostCodeMasked ??
    row?.fields?.meta?.hostCodeMasked ??
    row?.labels?.meta?.hostCodeMasked ??
    row?.stream?.meta?.hostCodeMasked ??
    row?.parsed?.meta?.hostCodeMasked;

  const directActorUsername =
    row?.actorUsername ??
    row?.fields?.actorUsername ??
    row?.labels?.actorUsername ??
    row?.stream?.actorUsername ??
    row?.parsed?.actorUsername;

  if (directAction || directHostCodeMasked || directActorUsername) {
    return {
      action: safeStr(directAction),
      hostCodeMasked: safeStr(directHostCodeMasked),
      actorUsername: safeStr(directActorUsername),
    };
  }

  const msg = getMsg(row) || "";

  const parsed = tryParseJson(msg);
  if (parsed) {
    const a = parsed.action ?? parsed?.fields?.action ?? parsed?.labels?.action;
    const h = parsed?.meta?.hostCodeMasked ?? parsed?.fields?.meta?.hostCodeMasked ?? parsed?.labels?.meta?.hostCodeMasked;
    const u = parsed.actorUsername ?? parsed?.fields?.actorUsername ?? parsed?.labels?.actorUsername;

    if (a || h || u) return { action: safeStr(a), hostCodeMasked: safeStr(h), actorUsername: safeStr(u) };

    const msg2 = typeof parsed.message === "string" ? parsed.message : "";
    const r2 = extractFromAuditEventString(msg2);
    if (r2.action || r2.hostCodeMasked || r2.actorUsername) return r2;
  }

  return extractFromAuditEventString(msg);
}

export function formatAuditCell({ action, hostCodeMasked, actorUsername }) {
  return {
    action: safeStr(action),
    hostCodeMasked: safeStr(hostCodeMasked),
    actorUsername: safeStr(actorUsername),
  };
}

function extractFromAuditEventString(s) {
  const action = s.match(/action=([^,\]]+)/)?.[1] ?? "";
  const hostCodeMasked = s.match(/hostCodeMasked=([^,\]]+)/)?.[1] ?? "";
  const actorUsername = s.match(/actorUsername=([^,\]]+)/)?.[1] ?? "";
  return { action: safeStr(action), hostCodeMasked: safeStr(hostCodeMasked), actorUsername: safeStr(actorUsername) };
}

function tryParseJson(s) {
  if (!s || s[0] !== "{") return null;
  try {
    return JSON.parse(s);
  } catch {
    return null;
  }
}

function safeStr(v) {
  if (v == null) return "";
  const t = String(v).trim();
  if (!t || t === "null" || t === "undefined") return "";
  return t;
}
